<script setup lang="ts">
import { defineProps,defineEmits,computed,ref,watch } from 'vue'
const emit = defineEmits(['update:voteResult'])

const props = defineProps({  
        

    voteResult: {
        type: Boolean,
        required: false,
    },
    voteObject: {
        type: Object,
        required: false,
    },

    
})

const boolChange = () => {
    emit('update:voteResult',false)
}
const countdown = ref(120); // 初始化为 120 秒

const lasttime = computed(() => {
    const minutes = String(Math.floor(countdown.value / 60)).padStart(2, '0');
    const seconds = String(countdown.value % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;

})
watch(() => props.voteResult, (newVal: any) => {

    if (newVal) {
        // 启动一个计时器，每秒递减 countdown 值
        const timer = setInterval(() => {
            if (countdown.value > 0) {
                countdown.value -= 1;
            } else {
                // 当 countdown 达到 0 时，停止计时器，或执行其他操作
                clearInterval(timer);
            }
        }, 1000);
    }
})
</script>
<template>
   <div class="loading sm fixed flex a-center j-center column" :class="props.voteResult? 'active': ''">
     
        <!-- <span class="icon-close abs db_close white" @click="boolChange()"></span> -->
        <h1 class="heading1 white mb-40">Voting Results</h1> 
        <div class="flex column a-center gap-10 mt-10">
            <h2 class="heading2 white">Vote 1: Best Team</h2> 
            <div class="db_voteitem">
                {{ props.voteObject?.bestTeam }}
            </div>
            <p class="heading4">Total votes: {{ props.voteObject?.teamVotes }}</p> 
            
        </div>
        <div class="flex column a-center gap-10 mt-10">
            <h2 class="heading2 white">Vote 2: Best Debater</h2> 
            <div class="db_voteuser white" v-if="props.voteObject?.bestDebater">
                <img class="avatar-xs" :src="props.voteObject?.bestDebater.avatar?.file_id? `/api/v1/user/avatar/storage/${props.voteObject?.bestDebater.avatar.file_id}`: '/avatar-default.png'">
                
                <h4 class="title-3 white">{{ props.voteObject?.bestDebater.nick_name }} </h4>
            </div >
            <div class="db_voteuser white" v-else>
                不分胜负（No Winner: Draw）
            </div >
            
            <p class="heading4">Total votes: {{ props.voteObject?.debaterVotes }}</p> 
        </div>
        <p class="heading4 mt-20 alert">会议即将于{{ lasttime }}内关闭</p> 
 </div>
</template>

<style scoped>
@import '../assets/styles/frontpage.css';

.loading.sm{
    width: 90vw;
    height: 70vh;
    max-width: 700px;
    max-height: 600px;
    background: #1A1B1C;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.db_voteitem, .db_voteuser{
    border-radius: 30px;
    color: white;
    background:  rgba(81, 80, 80, 0.50);
    display: inline-flex;
    align-items: center;
    gap: 10px;
    border: 3px solid  rgba(81, 80, 80, 0.50);;
    padding: 10px 20px;
}
.db_close{
    right:20px;
    top: 20px;
}

</style>